import Button from '../ui/Button';

type Q1CertificatePanelProps = {
    pdf: string;
    downloadLabel: string;
};

export default function Q1CertificatePanel({ pdf, downloadLabel }: Q1CertificatePanelProps) {
    return (
        <div className="w-full">
            <div className="relative h-[206px] lg:h-[430px] w-full overflow-hidden rounded-lg border border-light-grey bg-white">
                <iframe
                    title="Q1 certificate preview"
                    src={`${pdf}#toolbar=0&navpanes=0`}
                    className="h-full w-full"
                />
            </div>
            <a href={pdf} download className="mt-4 inline-block w-fit">
                <Button title={downloadLabel} withArrow variant="secondary" />
            </a>
        </div>
    );
}
